export enum SigningTypeEnum{
    SES = 1,
    AES = 2
}


export interface SigningTypeViewModel{
    id: SigningTypeEnum;
    name: string;
}


// Export list of signing types
export const SigningTypes: SigningTypeViewModel[] = [
    { id: SigningTypeEnum.SES, name: 'Firma Electrónica Simple' },
    { id: SigningTypeEnum.AES, name: 'Firma Electrónica Avanzada' }
];
